module.exports = __webpack_public_path__ + "images/category_lp/furniture/assessment_achievements/1_44bf58edf66161ac2ca30ddae1ad4b92.png";